import { facultyTeachingPresets } from "./faculty-teaching";
import { researchPublicationsPresets } from "./research-publications";
import { earlyCareerPhdPresets } from "./early-career-phd";
import type { GalleryPreset } from "../types";

export * from "./faculty-teaching";
export * from "./research-publications";
export * from "./early-career-phd";

/**
 * All 17 Flagship Presets across the 3 core academic categories.
 */
export const ALL_FLAGSHIP_PRESETS: GalleryPreset[] = [
  ...facultyTeachingPresets,
  ...researchPublicationsPresets,
  ...earlyCareerPhdPresets,
];
